module.exports = __webpack_public_path__ + "media/images/chat-delete-230d9393.svg";